import { call, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';

// Redux
import { postRobotRegForm, postRobotRegFormSuccess, postRobotRegFormFailure } from '../../redux/RobotRegFormSlice';

// Services
import { postRobotRegFormApi } from '../../services/RobotRegFormApi';

// Shared
import { successResponse } from '../../../../shared/types';
import { getErrorMessage } from '../../../../shared/utils/apiRequest';

function* postRobotRegFormSaga(action: ReturnType<typeof postRobotRegForm>) {
    try {
        const response: successResponse = yield call(postRobotRegFormApi.postRobotRegForm, action.payload);
        const successMessage = response.data.message;
        toast.success(successMessage);
        const emailSentResponse: successResponse = yield call(postRobotRegFormApi.sendRegSuccessEmail, action.payload);
        const emailSentSuccessMessage = emailSentResponse.data?.message;
        toast.success(emailSentSuccessMessage);
        yield put(postRobotRegFormSuccess(successMessage));
    } catch (error: any) {
        const message = getErrorMessage(error);
        toast.error(message);
        yield put(postRobotRegFormFailure(message));
    }
}

export function* robotRegFormSaga() {
    yield takeLatest(postRobotRegForm.type, postRobotRegFormSaga);
}